export default String.raw`
.offline-container{
	height: calc(100vh - 17px);
	width: calc(100vw - 17px);
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	.logo{
		position: absolute;
		top: 50px;
		left: 50px;
		img{
			max-width: 200px;
			max-height: 80px;
		}
	}
	.content{
		line-height: normal;
		text-align: center;
		img{
			max-height: 50vh;
		}
	}
	.bold-text{
		margin-top: 50px;
		font-size: 48px;
		font-weight: 700;
	}
	.light-text{
		margin-top: 15px;
		font-size: 24px;
	}
}

@media only screen and (max-width: 1279px) {
	.offline-container{
		height: 100vh;
		width: 100vw;
		.logo{
			top: 10px;
			left: 10px;
			img{
				max-width: 100px;
				max-height: 40px;
			}
		}
		.content{
			padding: 0 30px;
		}
		.bold-text{
			font-size: 25px;
		}
		.light-text{
			margin-top: 10px;
			font-size: 15px;
		}
	}
}
`